import { Loader, BreakPoints } from '@kanda-libs/ks-design-library';

import Container from './StaffLogin-container';
import Mobile from './Mobile';
import Desktop from './Desktop';

const ViewComponent = ({}) => (
  <Container>
    {({ isSubmitting, ...restProps }) => (
      <>
        <BreakPoints
          mobile={<Mobile {...restProps} />}
          desktop={<Desktop {...restProps} />}
        />
        <Loader isLoading={isSubmitting} />
      </>
    )}
  </Container>
);

ViewComponent.displayName = 'StaffLogin-view';

export default ViewComponent;
